// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.back_btn{
    color: #A9ACB4;
    font-weight: 400;
    font-size: 14px;
}

.addPrompt_heading{
    color: var(--uni_std_clr);
    /* color: #0066CC; */
    font-size: 16px;
    font-weight: 600;
    line-height: 100%;
    font-style: "Semi Bold";
    
}

.addPrompt_subheading{
    color: #838FB4;
    font-size: 14px;
    font-weight: 400;
    line-height: 100%;
}

.addPrompt_wrapper label{
    font-weight: 600;
}

.addPrompt_wrapper select{
    color: #838FB4;
}

.form-select:focus {
    box-shadow: none;
}

.addPromptTextarea{
    min-height: 59px !important;
}

.addVaribaleBtn{
    border-radius: 4px;
    color: var(--uni_std_clr);
    box-shadow: 0px 0.5px 2.5px 0px #0000004D;
}

.resetBtn{
    box-shadow: 0px 0.5px 2.5px 0px #0000004D;
}

.submitBtn{
    background-color: var(--uni_std_clr);
    color: #FFFFFF;
    border-radius: 4px;
}

.btnDelete:hover{
    background: #F2F7FE;
}

/* Toogle button start */
.addPromptToggle .toggle-container {
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: Arial, sans-serif;
}

.addPromptToggle .label {
    font-size: 14px;
    line-height: 20px;
    color: #838FB4;
    transition: color 0.3s;
}

.addPromptToggle .label.active {
    color: var(--uni_std_clr);
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

.addPromptToggle .switch {
    width: 30px;
    height: 17px;
    background-color: #ccc;
    border-radius: 50px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s;
}

.addPromptToggle .switch.public {
    background-color: #007bff;
}

.addPromptToggle .slider-circle {
    width: 13px;
    height: 13px;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: left 0.3s;
}

.addPromptToggle .switch.public .slider-circle {
    left: 15px;
}
/* Toogle button end */

`, "",{"version":3,"sources":["webpack://./src/components/AddPrompt/AddPrompt.css"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;AACA,sBAAsB","sourcesContent":["\n.back_btn{\n    color: #A9ACB4;\n    font-weight: 400;\n    font-size: 14px;\n}\n\n.addPrompt_heading{\n    color: var(--uni_std_clr);\n    /* color: #0066CC; */\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 100%;\n    font-style: \"Semi Bold\";\n    \n}\n\n.addPrompt_subheading{\n    color: #838FB4;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 100%;\n}\n\n.addPrompt_wrapper label{\n    font-weight: 600;\n}\n\n.addPrompt_wrapper select{\n    color: #838FB4;\n}\n\n.form-select:focus {\n    box-shadow: none;\n}\n\n.addPromptTextarea{\n    min-height: 59px !important;\n}\n\n.addVaribaleBtn{\n    border-radius: 4px;\n    color: var(--uni_std_clr);\n    box-shadow: 0px 0.5px 2.5px 0px #0000004D;\n}\n\n.resetBtn{\n    box-shadow: 0px 0.5px 2.5px 0px #0000004D;\n}\n\n.submitBtn{\n    background-color: var(--uni_std_clr);\n    color: #FFFFFF;\n    border-radius: 4px;\n}\n\n.btnDelete:hover{\n    background: #F2F7FE;\n}\n\n/* Toogle button start */\n.addPromptToggle .toggle-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-family: Arial, sans-serif;\n}\n\n.addPromptToggle .label {\n    font-size: 14px;\n    line-height: 20px;\n    color: #838FB4;\n    transition: color 0.3s;\n}\n\n.addPromptToggle .label.active {\n    color: var(--uni_std_clr);\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.addPromptToggle .switch {\n    width: 30px;\n    height: 17px;\n    background-color: #ccc;\n    border-radius: 50px;\n    position: relative;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.addPromptToggle .switch.public {\n    background-color: #007bff;\n}\n\n.addPromptToggle .slider-circle {\n    width: 13px;\n    height: 13px;\n    background-color: #fff;\n    border-radius: 50%;\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    transition: left 0.3s;\n}\n\n.addPromptToggle .switch.public .slider-circle {\n    left: 15px;\n}\n/* Toogle button end */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
